import React, { ReactElement } from 'react'

import styles from './Footer.module.less'

export const Footer: React.FC<unknown> = (): ReactElement => {
    return (
        <footer className={styles.footer}>
            © {new Date().getFullYear()} Just Enough Prep All rights reserved.
        </footer>
    )
}
